import * as types from '../../constants/actionTypes';

export default function reset() {
	return {
		type: types.ADMIN_NOTIFICATION_RESET_MESSAGE,
	};
}



// WEBPACK FOOTER //
// ./src/actions/adminNotifications/resetAdminNotificationMessage.js